"use client";
import React, { Suspense } from "react";
const Impl = React.lazy(() => import("./CalendarImpl"));
export default function CalendarBoundary(props: any) {
  return <Suspense fallback={null}><Impl {...props} /></Suspense>;
}

